export const uk = {
    direct: 'Директ'
};
